import { Controller, useFormContext } from "react-hook-form";
import { ProductVariantSelect } from "@/components/ProductVariantSelect";
import BookDisplay from "@/components/BookDisplay";
import { SubscriptionProduct } from "@cappelendamm/e-commerce-services";

export type BookSelectorProps = {
  subscription: SubscriptionProduct;
};

export type BookSelectorForm = {
  meta: {
    initialSku: string;
  };
};

export const BookSelector = ({ subscription }: BookSelectorProps) => {
  const { control } = useFormContext<BookSelectorForm>();
  const books = subscription.series?.products ?? [];
  const isBookSelectionEnabled = subscription.productSelector ?? false;
  const isFirstBookFree = subscription.isDiscountedFirstBook;

  if (!books || books.length === 0) return null;

  const selectorItems = books.map((book) => {
    return {
      key: book.sku,
      title: book.name ?? "",
      subTitle: book.numberInSeries ? `Bok ${book.numberInSeries}` : "",
      image: book.image
        ? {
            src: book.image,
            alt: book.name ?? "Bokforside",
            aspectRatio: 4 / 6,
          }
        : undefined,
      additionalInfo:
        isFirstBookFree && book.numberInSeries === 1 ? "Gratis bok" : "",
    };
  });

  if (!isBookSelectionEnabled && selectorItems[0]) {
    const firstSelectorItem = selectorItems[0];
    return (
      <BookDisplay
        title={firstSelectorItem.title}
        subTitle={firstSelectorItem.subTitle}
        image={firstSelectorItem.image}
      />
    );
  }

  return (
    <div className="w-full space-y-1 text-center">
      <label htmlFor="book-selector" className="font-semibold">
        Start abonnementet med:
      </label>

      <Controller
        name={`meta.initialSku`}
        control={control}
        render={({ field: { value, onChange, ...field } }) => (
          <ProductVariantSelect
            id="book-selector"
            theme="elevated"
            items={selectorItems}
            value={selectorItems.find((book) => book.key === value)}
            onChange={(item) => onChange(item.key)}
            {...field}
          />
        )}
      />
    </div>
  );
};
